/**
 * Determines the color for progress percentage based on the value
 * @param {number} percentage - The progress percentage (0-100)
 * @returns {string} - The color name for Ant Design Tag component
 */
export const getProgressColor = (percentage) => {
  const numericPercentage = parseFloat(percentage) || 0;
  
  if (numericPercentage < 30) {
    return 'Red';
  } else if (numericPercentage < 70) {
    return 'Orange';
  } else {
    return 'Green';
  }
};

/**
 * Determines the progress status text based on percentage
 * @param {number} percentage - The progress percentage (0-100)
 * @returns {string} - The status text
 */
export const getProgressStatus = (percentage) => {
  const numericPercentage = parseFloat(percentage) || 0;
  
  if (numericPercentage < 30) {
    return 'Off Track';
  } else if (numericPercentage < 70) {
    return 'At Risk';
  } else {
    return 'On Track';
  }
};